import type { ReactNode, FC, Ref } from "react";
import { Flex, Grid, Heading, PricingCard, Columns } from "@huub-web/ui";

export interface AdvicePricingProps {
  cta?: ReactNode;
}

/**
 * @deprecated
 */
export const AdvicePricing: FC<
  AdvicePricingProps & { ref?: Ref<HTMLDivElement> }
> = ({ cta, ref }) => (
  <Flex direction="column" gap="l" ref={ref}>
    <Heading
      title="Alleen betalen bij succes"
      description="Of je net begint of al een bod uit wilt brengen: we laten je graag zien hoe onze begeleiding eruitziet — en welke kosten daarbij horen. Zo weet je precies wat je kunt verwachten."
    />
    <Grid variant="threeColumnMarketing">
      <PricingCard
        title="Gratis"
        price={0}
        subtitle="Vrijblijvend"
        description="Krijg direct inzicht in woningen en maak kennis met een van onze hypotheekadviseurs. "
        features={[
          { title: "30 min kennismakingsgesprek", included: true },
          { title: "Woninganalyse", included: true },
          { title: "AI hypotheekassistent", included: true },
          { title: "Biedcertificaat", included: false },
          {
            title: "Hypotheekadvies, van aanvraag tot afsluiten",
            included: false,
          },
        ]}
      />
      <PricingCard
        title="Starter"
        price={2495}
        subtitle="No cure, no pay"
        description="Complete begeleiding bij de aankoop van je eerste woning, van eerste advies tot notaris."
        features={[
          { title: "Onbeperkte begeleiding", included: true },
          { title: "Woninganalyse", included: true },
          { title: "AI hypotheekassistent", included: true },
          { title: "Biedcertificaat", included: true },
          {
            title: "Hypotheekadvies, van aanvraag tot afsluiten",
            included: true,
          },
        ]}
      />
      <PricingCard
        title="Doorstromer"
        price={2795}
        subtitle="No cure, no pay"
        description="Volledig adviestraject voor aankoop én het oversluiten van je bestaande hypotheek."
        features={[
          { title: "Onbeperkte begeleiding", included: true },
          { title: "Woninganalyse", included: true },
          { title: "AI hypotheekassistent", included: true },
          { title: "Biedcertificaat", included: true },
          {
            title: "Hypotheekadvies, van aanvraag tot oversluiten",
            included: true,
          },
        ]}
      />
    </Grid>
    {cta && <Columns>{cta}</Columns>}
  </Flex>
);
